import { Identifiable, Milestone } from "@planzone/dto";
import { Filter } from "@planzone/dto";

import { isFilteredByTags } from "./projectsElementsTags";

function isMilestoneFiltered(
  milestone: Identifiable<Milestone>,
  filter: Filter,
): boolean {
  return [isFilteredByTags].reduce(
    (isFiltered, applyFilter) =>
      isFiltered ? isFiltered : applyFilter(milestone, filter),
    false,
  );
}

export { isMilestoneFiltered };
